// assets/scroll-to-top.js
document.addEventListener('DOMContentLoaded', function () {
  var scrollBtn = document.getElementById('scrollTopBtn');
  if (!scrollBtn) return;

  var showOffset = 300; // px to show button

  var onScroll = function () {
    var y = window.scrollY || window.pageYOffset;
    if (y > showOffset) scrollBtn.classList.add('is-visible');
    else scrollBtn.classList.remove('is-visible');
  };

  // initial check
  onScroll();

  // efficient scroll listener
  window.addEventListener('scroll', onScroll, { passive: true });

  // click -> smooth scroll top
  scrollBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.blur();
  });

  // allow keyboard activation (Enter/Space)
  scrollBtn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click();
    }
  });
});
